let index = 0

export function getUID(): number {
  return index++
}
